import "primevue/resources/themes/bootstrap4-light-blue/theme.css"
import 'asdecode-datatable/theme/css/asdecode-datatable-bs4.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import './style/app.scss';


import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import PrimeVue from 'primevue/config';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Paginator from 'primevue/paginator';
import DynamicDialog from 'primevue/dynamicdialog';
import DialogService from 'primevue/dialogservice';
import ProgressSpinner from 'primevue/progressspinner';
import Image from 'primevue/image';
import FileUpload from 'primevue/fileupload';
import Editor from "primevue/editor";
import ProgressBar from 'primevue/progressbar';
import DataView from 'primevue/dataview';
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Chart from 'primevue/chart';
import SelectButton from 'primevue/selectbutton';

import AsdecodeTable from 'asdecode-datatable/src/components/AsdecodeTable.vue';

//parametres cors et la base url des requetes dans la spa
axios.defaults.withCredentials = true
axios.defaults.baseURL = store.getters.apiUrl

//si l'utilisateur s'est déjà connecté
const mysession = window.localStorage.getItem("panel_freelance_asdecode")
if (mysession !== null) {
  const userDatas = JSON.parse(mysession);
  store.commit('setAuthenticated', userDatas);
}

//si le profil de l'utilisateur est déjà sauvegardé
const momProfil = window.localStorage.getItem("profil_asdecode")
if (momProfil !== null) {
  const membershipDatas = JSON.parse(momProfil);
  store.commit('setMembership', membershipDatas);
}


const app = createApp(App);
app.use(VueAxios, axios)
app.use(PrimeVue)
app.use(store)
app.use(router)
app.use(DialogService)
app.use(ToastService)
app.component('DataTable', DataTable);
app.component('DataTableColumn', Column);
app.component('DataPaginator', Paginator);
app.component('DynamicDialog', DynamicDialog);
app.component('AsdecodeTable', AsdecodeTable);
app.component('ProgressSpinner', ProgressSpinner);
app.component('ShowImage', Image);
app.component('FileUpload', FileUpload);
app.component('TextEditor', Editor);
app.component('ProgressBar', ProgressBar);
app.component('DataView', DataView);
app.component('DataViewLayoutOptions', DataViewLayoutOptions);
app.component('ShowToast', Toast);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('ChartJS', Chart);
app.component('SelectButton', SelectButton);
app.mount('#app')